import { Link } from "react-router-dom";

export const DemoShowcase = () => (
  <section className="section dark" id="demo">
    <div className="section-inner">
      <span className="section-eyebrow">See it in action</span>
      <h2>Bancony Assistant, inside a bank.</h2>
      <p className="lede">
        A short, unedited walk-through. The Assistant lives inside the bank's own
        digital banking, picks up the customer's authenticated session, and helps with
        everyday tasks in natural language: checking balances, reviewing spending,
        preparing a transfer. The bank's brand, the bank's controls, the bank's data.
      </p>

      <div className="demo-frame">
        <img
          src="/img/demo.gif"
          alt="Bancony Assistant answering customer questions and showing account information inside a bank's digital banking app"
          className="demo-frame-image"
          loading="lazy"
          decoding="async"
        />
      </div>

      <p className="demo-caption">
        Want to see it against your own data and brand?{" "}
        <Link to="/contact?intent=demo" className="btn-arrow">Book a live demo</Link>
      </p>

      <p className="demo-caption demo-caption-secondary">
        Already have demo credentials, or want them?{" "}
        <a
          href="https://demo.bancony.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-arrow"
        >
          Try it yourself on demo.bancony.com
        </a>
      </p>
    </div>
  </section>
);
